/**
 * @owner @Appboy/email
 */

import { z } from "zod/v4";

// The link hashes are built by the server (LinkAliasDraftDataHelper#new_link_hash) and echoed back
// by the composer. Links that have no alias yet (freshly discovered in the HTML, or link-template-only
// links under link_management_without_link_aliasing) are built with name/lid/original_name = nil.
// LinkAliasPersistHelper only applies a name when it is present.
export const emailLinkPostSchema = z.object({
  name: z.string().nullable().optional(),
  active: z.boolean(),
  url: z.string(),
  original_name: z.string().nullable().optional(),
  link_templates: z.record(z.string(), z.record(z.string(), z.string())).optional(),
  is_tracked: z.boolean(),
  lid: z.string().nullable().optional(),
  nested: z.boolean().optional(),
  is_draft: z.boolean().optional(),
});
